import { render } from "./RegionDetail.vue?vue&type=template&id=5f56fe30&scoped=true"
import script from "./RegionDetail.vue?vue&type=script&lang=js"
export * from "./RegionDetail.vue?vue&type=script&lang=js"

import "./RegionDetail.vue?vue&type=style&index=0&id=5f56fe30&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f56fe30"]])

export default __exports__